module.exports = __webpack_public_path__ + "static/media/temenos.a29f9768.jpg";